import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EarningCode from './earningCode';
import ECExportText from './earningCodeExportName';
import LocationCostCenter from './locationCostCenter';
import { getSOHSettings, saveSOHSettings, getEarningCodes } from '../../../../../../store/actions';
import Switch from '../../../../../../components/switch';

const SOHTool = props => {

    const [earningCodes, setEarningCodes] = useState([]);
    const [useTimeInterval, setUseTimeInterval] = useState(false);

    useEffect(() => {
        getSettings(props.ClientDataReducer._id);
    }, []);

    async function getSettings(companyId) {
        await props.getSOHSettings(companyId);
        setEarningCodes(props.SOH_SETTINGS?.earningCodes || []);
        setUseTimeInterval(props.SOH_SETTINGS?.useTimeInterval || false);
    };

    async function saveTimeInterval() {
        await props.saveSOHSettings(props.ClientDataReducer._id, { useTimeInterval });
    };

    return (
        <>
            <div className="df align-items-center justify-content-between margin-top-10">
                <button
                    className="btn reportBtn"
                    onClick={saveTimeInterval}
                    disabled={useTimeInterval == props.SOH_SETTINGS?.useTimeInterval}
                >
                    Save
                </button>
            </div>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography className="titleAccording">
                        EARNING CODES
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <div className="reportId">
                        <EarningCode
                            earningCodes={earningCodes}
                            saveSettings={saveSOHSettings}

                        ></EarningCode>
                    </div>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography className="titleAccording">EARNING CODE EXPORT TEXT</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <div className="reportListAccording mar-0">
                        <ECExportText></ECExportText>
                    </div>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography className="titleAccording">
                        COST CENTER
                    </Typography>
                </AccordionSummary>

                <AccordionDetails>
                    <LocationCostCenter></LocationCostCenter>
                </AccordionDetails>
            </Accordion>
            <div className="df align-items-center justify-content-between">
                <span className="titleAccording">Spread-based Calculation</span>
                <Switch
                    value={useTimeInterval}
                    onChange={e => setUseTimeInterval(e.target.checked)}
                    name="useTimeInterval"
                />
            </div>
        </>

    )
};

const mapStateToProps = ({ ClientDataReducer, SOHSettingsReducer }) => {
    let { SOH_SETTINGS, EARNING_CODES } = SOHSettingsReducer;
    return { ClientDataReducer, SOH_SETTINGS, EARNING_CODES };
};

export default connect(mapStateToProps, {
    getSOHSettings,
    saveSOHSettings,
    getEarningCodes
})(SOHTool);